import * as React from 'react';
import { DEFAULT_TABLE_PAGE_SIZE } from '../../../../../../../common/components/table/constants';
import { ITEM_TYPE_CONTRACT } from '../../../../../../../common/config/api_constants';
import ContractActions from '../components/ContractActions';
import { getImportStatusHeaderDescriptionForGroupingPage } from '../../../../../../import_data/utils/import_utils';
import { SUPPORTED_IMPORT_TYPES } from '../../../../../../import_data/constants/import_types';

const EmptyTableView = () => <p>No Contract.</p>;

export default ({ importTypeMetadata, data }) => {
  return {
    dataTrackingId: 'partitionKey',
    dataLoadingText: 'Loading contracts.',
    emptyElement: EmptyTableView,
    pageSize: DEFAULT_TABLE_PAGE_SIZE,
    multiSelectConfig: { selectionType: 'multi' }, // add selection type here
    headerConfig: {
      title: 'Grouping',
      description: getImportStatusHeaderDescriptionForGroupingPage(importTypeMetadata, data),
      Actions: ContractActions,
      importTypeMetadata,
    },
    getDataRequestBody: () => {
      return {
        itemType: ITEM_TYPE_CONTRACT,
      };
    },
    getImportDataRequestBody: () => {
      return {
        body: {
          importTypes: SUPPORTED_IMPORT_TYPES.CONTRACT_GROUPING,
        },
      };
    },
  };
};
